(function () {
  'use strict';

  var lockCount = 0;

  function readLockedScrollY() {
    var fromDataset = parseInt(document.body.dataset.rabitatScrollLockY || '', 10);
    if (!isNaN(fromDataset)) {
      return fromDataset;
    }

    var top = document.body.style.top;
    if (top) {
      var parsed = parseInt(top, 10);
      if (!isNaN(parsed)) {
        return Math.abs(parsed);
      }
    }

    return window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function releaseBodyScrollLock() {
    var scrollY = readLockedScrollY();

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.documentElement.classList.remove('rabitat-scroll-lock');
    document.body.classList.remove('rabitat-scroll-lock');
    delete document.body.dataset.rabitatScrollLockY;

    window.scrollTo(0, scrollY);
    window.requestAnimationFrame(function () {
      window.scrollTo(0, scrollY);
    });
  }

  function lockScroll() {
    lockCount += 1;
    if (lockCount > 1) return;

    var scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.dataset.rabitatScrollLockY = String(scrollY);
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.documentElement.classList.add('rabitat-scroll-lock');
    document.body.classList.add('rabitat-scroll-lock');
  }

  function unlockScroll() {
    if (lockCount <= 0) {
      if (document.body.style.position === 'fixed') {
        lockCount = 0;
        releaseBodyScrollLock();
      }
      return;
    }

    lockCount -= 1;
    if (lockCount > 0) return;

    releaseBodyScrollLock();
  }

  function forceUnlockScroll() {
    lockCount = 0;
    if (document.body.style.position === 'fixed' || document.body.classList.contains('rabitat-scroll-lock')) {
      releaseBodyScrollLock();
    } else {
      document.documentElement.classList.remove('rabitat-scroll-lock');
      document.body.classList.remove('rabitat-scroll-lock');
      delete document.body.dataset.rabitatScrollLockY;
    }
  }

  window.RabitatScrollLock = {
    lock: lockScroll,
    unlock: unlockScroll,
    forceUnlock: forceUnlockScroll
  };
})();
